import { IEltCompanyPerformanceItem } from 'legacy/lut/classes/models/partner360/ELT/docEltType/IEltCompanyPerfomance'
import { CUSTOMER_REVENUE_TOTAL } from 'legacy/lut/components/widgets/public/partner360/ELT/configs'
import { getFieldByActualsValueType } from 'legacy/lut/components/widgets/public/partner360/ELT/helpers/getFieldByActualsValueType'
import { getFormedEltTranslation } from 'legacy/lut/components/widgets/public/partner360/ELT/helpers/getFormedEltTranslation'
import { ShortRevenueName } from 'legacy/lut/components/widgets/public/partner360/ELT/ui/revenue/revenueCommon/shortRevenueName/ShortRevenueName'
import { ShortYearRevenue } from 'legacy/lut/components/widgets/public/partner360/ELT/ui/revenue/revenueCommon/shortYearRevenue/ShortYearRevenue'
import { IColumn } from 'legacy/lut/components/widgets/public/partner360/ELT/ui/styledComponents/styledTable/types'

import { Translation } from 'cng-common/features/translations'
import { ActualsValueTypes } from 'partner360/models/actualValueTypes'

interface IProps {
  onChange: (field: string, keyValue: string) => (value: string | number) => void
  currentYear: number
  netNdpValue: ActualsValueTypes
}

export const getCompanyPerformanceColumns = ({
  currentYear,
  netNdpValue,
  onChange,
}: IProps): IColumn<IEltCompanyPerformanceItem>[] => {
  const prev2YearField = getFieldByActualsValueType<IEltCompanyPerformanceItem>(
    'Prev2YearTotal',
    netNdpValue
  )

  const prevYearField = getFieldByActualsValueType<IEltCompanyPerformanceItem>(
    'PrevYearTotal',
    netNdpValue
  )

  const curYearField = getFieldByActualsValueType<IEltCompanyPerformanceItem>(
    'CurYearTotal',
    netNdpValue
  )

  return [
    {
      title: getFormedEltTranslation('company-performance-table-name'),
      field: 'TranslationKey',
      renderComponent: ({ value, keyValue }) => (
        <ShortRevenueName value={value || ''} keyValue={keyValue} />
      ),
    },
    {
      field: prev2YearField,
      titleRenderFn: () => (
        <div>
          <Translation
            text={getFormedEltTranslation('company-performance-table-prev2year')}
            replaceParams={[{ key: '{year}', value: String(currentYear - 2) }]}
          />
        </div>
      ),
      renderComponent: ({ value, keyValue }) => (
        <ShortYearRevenue
          value={value || ''}
          keyValue={keyValue}
          field={prev2YearField}
          onChange={onChange}
          isEditable={keyValue !== CUSTOMER_REVENUE_TOTAL}
        />
      ),
    },
    {
      field: prevYearField,
      titleRenderFn: () => (
        <div>
          <Translation
            text={getFormedEltTranslation('company-performance-table-prev-year')}
            replaceParams={[{ key: '{year}', value: String(currentYear - 1) }]}
          />
        </div>
      ),
      renderComponent: ({ value, keyValue }) => (
        <ShortYearRevenue
          value={value || ''}
          keyValue={keyValue}
          field={prevYearField}
          onChange={onChange}
          isEditable={keyValue !== CUSTOMER_REVENUE_TOTAL}
        />
      ),
    },
    {
      field: curYearField,
      titleRenderFn: () => (
        <div>
          <Translation
            text={getFormedEltTranslation('company-performance-table-cur-year')}
            replaceParams={[{ key: '{year}', value: String(currentYear) }]}
          />
        </div>
      ),
      renderComponent: ({ value, keyValue }) => (
        <ShortYearRevenue
          value={value || ''}
          keyValue={keyValue}
          field={curYearField}
          onChange={onChange}
          isEditable={keyValue !== CUSTOMER_REVENUE_TOTAL}
        />
      ),
    },
  ]
}
